// extracted by mini-css-extract-plugin
export default {"leftAlign":"W_zZD90TEDN0XgiozBxe","rightAlign":"Vz54AuDm3Fwt_iFlCagF"};